export const VIDEO_TYPES = Object.freeze({
    PRACTICE_VIDEO: 'PRACTICE_VIDEO',
    SING_ALONG: 'SING_ALONG'
});